module.exports = __webpack_public_path__ + "static/media/moving_pipp.3f520643.png";